"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const history_1 = require("history");
const history = (0, history_1.createBrowserHistory)();
exports.default = history;
